import React, { Fragment, useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';
import './CellDocLibraryDocumentsNames.css';

type CellDocLibraryDocumentsNamesProps = {
    names: Array<{ name: string }>;
};

const CellDocLibraryDocumentsNames = ({ names }: CellDocLibraryDocumentsNamesProps) => {
    const renderDocumentsNames = useMemo(() => names.map((item) => (
        <Fragment key={uuidv4()}>
            <div>{item.name}</div>
        </Fragment>
    )), [names]);

    return <div className="CellDocLibraryDocumentsNames">{renderDocumentsNames}</div>;
};

export default CellDocLibraryDocumentsNames;
